import { render, staticRenderFns } from "./dsTanacsadasiVoucherProgram.vue?vue&type=template&id=4c540269&scoped=true"
import script from "./dsTanacsadasiVoucherProgram.vue?vue&type=script&lang=js"
export * from "./dsTanacsadasiVoucherProgram.vue?vue&type=script&lang=js"
import style0 from "./dsTanacsadasiVoucherProgram.vue?vue&type=style&index=0&id=4c540269&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c540269",
  null
  
)

export default component.exports